import { TextArea } from '@soteria/design-system-ve';

import { ClearButton } from './ClearButton';
import * as styles from './TextInputCard.css';

interface TextInputCardProps {
  textContent: string;
  hasError: boolean;
  onTextChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: () => void;
  onClear: () => void;
  textAreaRef: React.RefObject<HTMLTextAreaElement | null>;
}

/**
 * Text Input Card for typing text content
 */
export function TextInputCard({ textContent, hasError, onTextChange, onFocus, onClear, textAreaRef }: TextInputCardProps) {
  return (
    <div className={styles.textInputContainer}>
      <TextArea
        ref={textAreaRef}
        hasError={hasError}
        placeholder="Type or paste your text content here..."
        rows={4}
        size={{ height: 160 }}
        value={textContent}
        onChange={onTextChange}
        onFocus={onFocus}
      />
      {textContent && <ClearButton ariaLabel="Clear text input" title="Clear text" onClick={onClear} />}
    </div>
  );
}
